import { render, staticRenderFns } from "./Collection_Added.vue?vue&type=template&id=1932d087&scoped=true"
import script from "./Collection_Added.vue?vue&type=script&lang=js"
export * from "./Collection_Added.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1932d087",
  null
  
)

export default component.exports